<template>
  <div uk-grid>
    <Search/>
    <transition name="scale" appear>
    <List/>
    </transition>
  </div>
  <footer>
  </footer>
</template>

<script>
// @ is an alias to /src
import Search from '@/components/Search.vue'
import List from '@/components/List.vue'

export default {
  name: 'Home',
  components: {
    Search,
    List
  }
}
</script>


<style lang="scss">
.header_img {
  background-image: url('~@/assets/img/header.jpg');
}

.scale-enter {
  opacity: 0;
}

.scale-enter-active {
  animation: scale 1s;
  animation-delay: 1s;
}

.scale-leave-active {
}

@keyframes scale {
  from {
    opacity: 0;
    scale: 5;
  }
  to {
    opacity: 1;
    scale: 1;
  }
}
</style>
